import s from "./secondStep.module.css";
import CheckboxInput from "./CheckboxInput";
import {nadWhiteArrow} from "../../../../../assets";
import {useAppContext} from "../../../../../contexts";

const SecondStep = (props) => {
    // Destructured props
    const {
        formValues,
        handleChange,
        surveyData
    } = props;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    const badFlow = formValues.overallRating < 5;

    // All the available options
    const options = [
        ...(
            badFlow ? surveyData.improvableOptions : surveyData.enjoyableOptions
        )
    ].map((option) => {
        return (
            <CheckboxInput
                key={option.id}
                option={option}
                formValues={formValues}
                handleChange={handleChange}
            />
        )
    });

    // The text to be displayed at the heading element
    const headingText =
        badFlow ? "O que podemos melhorar?" : "Agora, nos conte o que mais gostou?";

    return (
        <div>
            <div>
                <h1 className={`${s.heading} ${highContrast ? "!text-[#fecc31]" : ""}`}>
                    {headingText}
                </h1>
                <p className={s.paragraph}>
                    Escolha quantas opções desejar
                </p>
            </div>
            <div className={"flex flex-row flex-wrap gap-2.5 mt-5"}>
                {options}
            </div>
            <button
                type={"submit"}
                className={`${s.submitButton} ${highContrast ? "highFormButton" : ""}`}
            >
                Prosseguir
                <img
                    src={nadWhiteArrow}
                    alt="White arrow"
                />
            </button>
        </div>
    )
}

export default SecondStep;
